
(function () {
  if (window.__aeIngredientFanInit) return;
  window.__aeIngredientFanInit = true;

  const ROT_TABLE = [0, 3.78, 7.52, 11.20, 14.79, 18.26, 21.60];
  const MAX_ROT_TABLE_IDX = ROT_TABLE.length - 1;

  function rotationFor(distance) {
    const sign = Math.sign(distance);
    const abs = Math.abs(distance);
    if (abs <= MAX_ROT_TABLE_IDX) return sign * ROT_TABLE[abs];
    const overshoot = abs - MAX_ROT_TABLE_IDX;
    return sign * (ROT_TABLE[MAX_ROT_TABLE_IDX] + overshoot * 3);
  }

  function init(stage) {
    if (stage.dataset.initialized === 'true') return;
    stage.dataset.initialized = 'true';

    const root = stage.closest('.ae-ingredient-fan') || stage;
    const cards = Array.from(stage.querySelectorAll('[data-card]'));
    const prevBtn = root.querySelector('[data-prev]');
    const nextBtn = root.querySelector('[data-next]');
    const progressBar = root.querySelector('[data-progress]');
    if (!cards.length) return;

    const total = cards.length;
    let active = parseInt(stage.dataset.initialActive || '0', 10);
    if (!Number.isFinite(active) || active < 0) active = 0;
    if (active > total - 1) active = total - 1;

    const cs = getComputedStyle(root);
    const stepX = parseFloat(cs.getPropertyValue('--ae-if-step-x')) || 330;
    const yCurve = parseFloat(cs.getPropertyValue('--ae-if-y-curve')) || 10.89;

    function layout() {
      cards.forEach((card, index) => {
        const distance = index - active;
        const tx = distance * stepX;
        const ty = distance * distance * yCurve;
        const rot = rotationFor(distance);
        card.style.transform = `translate(-50%, 0) translate(${tx}px, ${ty}px) rotate(${rot}deg)`;
        card.style.zIndex = String(100 - Math.abs(distance));

        const isActive = index === active;
        card.classList.toggle('is-active', isActive);
        card.setAttribute('aria-pressed', isActive ? 'true' : 'false');

        const collapsed = card.querySelector('.ae-ingredient-fan__face--collapsed');
        const expanded = card.querySelector('.ae-ingredient-fan__face--expanded');
        if (collapsed) collapsed.setAttribute('aria-hidden', isActive ? 'true' : 'false');
        if (expanded) expanded.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      if (prevBtn) prevBtn.disabled = active <= 0;
      if (nextBtn) nextBtn.disabled = active >= total - 1;

      if (progressBar) {
        const ratio = total <= 1 ? 1 : (active + 1) / total;
        const pct = Math.min(100, Math.max(12, ratio * 100));
        progressBar.style.transform = `scaleX(${pct / 100})`;
      }
    }

    function setActive(index) {
      const next = Math.max(0, Math.min(total - 1, index));
      if (next === active) return;
      active = next;
      layout();
    }

    cards.forEach((card) => {
      card.addEventListener('click', (event) => {
        if (card.dataset.dragCancelled === 'true') {
          card.dataset.dragCancelled = 'false';
          event.preventDefault();
          return;
        }
        const idx = parseInt(card.dataset.index, 10);
        if (!Number.isFinite(idx)) return;
        setActive(idx);
      });
    });

    prevBtn?.addEventListener('click', () => setActive(active - 1));
    nextBtn?.addEventListener('click', () => setActive(active + 1));

    let dragStartX = null;
    let dragStartActive = 0;
    let dragMoved = false;
    const DRAG_THRESHOLD = 6;
    const STEP_TO_SHIFT = stepX * 0.45;

    function onPointerDown(event) {
      if (event.button != null && event.button !== 0) return;
      dragStartX = event.clientX;
      dragStartActive = active;
      dragMoved = false;
      stage.setPointerCapture?.(event.pointerId);
    }

    function onPointerMove(event) {
      if (dragStartX == null) return;
      const dx = event.clientX - dragStartX;
      if (Math.abs(dx) < DRAG_THRESHOLD && !dragMoved) return;
      dragMoved = true;
      stage.classList.add('is-dragging');
      const offsetSteps = Math.round(-dx / STEP_TO_SHIFT);
      const candidate = Math.max(0, Math.min(total - 1, dragStartActive + offsetSteps));
      if (candidate !== active) {
        active = candidate;
        layout();
      }
    }

    function onPointerUp(event) {
      if (dragStartX == null) return;
      const wasDragged = dragMoved;
      dragStartX = null;
      stage.classList.remove('is-dragging');
      stage.releasePointerCapture?.(event.pointerId);
      if (wasDragged) {
        const target = event.target.closest('[data-card]');
        if (target) target.dataset.dragCancelled = 'true';
      }
    }

    stage.addEventListener('pointerdown', onPointerDown);
    stage.addEventListener('pointermove', onPointerMove);
    stage.addEventListener('pointerup', onPointerUp);
    stage.addEventListener('pointercancel', onPointerUp);

    stage.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        setActive(active - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        setActive(active + 1);
      }
    });

    layout();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ae-ingredient-fan]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) initAll(event.target);
  });
})();
